import { useTranslation } from 'react-i18next'
import { resolveLanguage } from '@dorixona/i18n'
import { Press } from '@dorixona/ui'
import { BackButton } from '../../../ui/BackButton'
import { Icon } from '../../../ui/Icon'
import { Failed } from '../../../ui/Load'
import { useOnVisible } from '../../../ui/useOnVisible'
import { useNewsPage } from '../api'
import { NewsCard, NewsCardSkeleton } from './NewsCard'

const SKELETON = [0, 1, 2]

/**
 * Все новости, новые сверху. Следующая порция просится сама, когда низ ленты
 * подходит к экрану; кнопка «Показать ещё» остаётся для клавиатуры, читалки
 * экрана и браузеров без IntersectionObserver.
 */
export function NewsListScreen() {
  const { t, i18n } = useTranslation(['home', 'common'])
  const language = resolveLanguage([i18n.language])
  const news = useNewsPage()
  const list = news.data?.items ?? []
  const loadMore = () => {
    void news.fetchNextPage()
  }
  const moreRef = useOnVisible(
    loadMore,
    news.hasNextPage && !news.isFetchingNextPage && !news.isFetchNextPageError,
  )

  return (
    <section className="screen news-screen">
      <div className="mhead">
        <BackButton to="/" />
        <h1>{t('home:news.title')}</h1>
      </div>

      {news.isPending ? (
        <div role="status" aria-busy="true">
          <span className="visually-hidden">{t('common:state.loading')}</span>
          <div className="news-list" aria-hidden="true">
            {SKELETON.map((i) => (
              <NewsCardSkeleton key={i} wide />
            ))}
          </div>
        </div>
      ) : null}

      {news.isError && !news.data ? (
        <Failed
          error={news.error}
          onRetry={() => {
            void news.refetch()
          }}
        />
      ) : null}

      {news.data ? (
        <>
          {list.length === 0 ? (
            <div className="card empty">
              <Icon name="i-info" size={54} />
              <div className="t">{t('home:news.empty')}</div>
              {t('home:news.emptyHint')}
            </div>
          ) : (
            <ul className="news-list">
              {list.map((item) => (
                <li key={item.id}>
                  <NewsCard item={item} language={language} wide />
                </li>
              ))}
            </ul>
          )}

          <div ref={moreRef} className="news-more">
            {news.isFetchingNextPage ? (
              <span role="status">{t('common:state.loading')}</span>
            ) : news.isFetchNextPageError ? (
              <Failed error={news.error} onRetry={loadMore} />
            ) : news.hasNextPage ? (
              <Press squish="chip" className="fbtn" onPress={loadMore}>
                {t('common:actions.showMore')}
              </Press>
            ) : null}
          </div>
        </>
      ) : null}
    </section>
  )
}
